module.exports = __webpack_public_path__ + "img/evalpend.55e46003.svg";